<template>
  <div class="wrapper" @click="cardClicked"><div class="card" :class="'card' + card" :style="cardStyle"
    ><div v-if="hasLeftEye" class="eye left" :style="{ backgroundColor: color }"
    ></div><div v-if="hasRightEye" class="eye right" :style="{ backgroundColor: color }"
    ></div></div><div v-if="overlay" class="overlay" :style="{ backgroundColor: overlay }"
  ></div><div v-if="isLastPlayed" class="last"
  ></div></div>
</template>

<script>
export default {
  name: 'Card',

  props: {
    card: { type: String, required: true },
    selected: { type: Boolean, default: false },
    overlayColor: { type: String, default: '' },
    isLastPlayed: { type: Boolean, default: false },
  },

  computed: {
    isJack () { return (this.card.charAt(0) == 'J'); },
    hasRightEye () { return this.isJack; },
    hasLeftEye () { return this.card == 'JC' || this.card == 'JD'; },
    color () { return (this.card.charAt(1) == 'D' || this.card.charAt(1) == 'H') ? 'red' : 'black'; },
    overlay () { return this.selected ? 'rgba(255, 192, 0, 0.7)' : this.overlayColor; },
    cardImage () {  return require('../assets/cards/' + this.card + '.png'); },
    cardStyle () {
      let style = {
        backgroundImage: 'url(\'' + this.cardImage + '\')',
        width: '24px', height: '59px',
        backgroundPosition: '-18px -26px'
      };
      if (this.card == 'WW') {
        style.backgroundPosition = 'center';
        style.backgroundSize = 'cover';
      }
      return style;
    }
  },

  methods: {
    cardClicked () { this.$emit('click', this.card); }
  }
}
</script>

<style scoped>
.wrapper { position: relative; margin: 2px; padding: 1px 4px; border-radius: 2px; background-color: white; display: inline-block; }
.wrapper .overlay { position: absolute; top: 0; left: 0; bottom: 0; right: 0; }
.wrapper .last { position: absolute; top: -3px; bottom: -3px; left: -3px; right: -3px; border: 3px dashed #ff0; border-radius: 4px; }
.card { background-repeat: no-repeat; }
.card .eye { position: absolute; top: 13px; width: 8px; height: 8px; border-radius: 4px; }
.card .eye.left { left: 1px; }
.card .eye.right { left: 10px; }

.cardWW { background-position: center; background-size: cover; }

/*
  width: 80px; height: 108px;
  background-position: center;
  background-size: cover;
  border-radius: 4px;
  margin: 1px 4px;
*/
</style>
